// extracted by mini-css-extract-plugin
export default {"StatusIndicatorCard":"RoleIndicatorCard_StatusIndicatorCard__fRvZG"};